import React from "react";
import {
  DialogContent,
  CardContent,
  Card,
  TableContainer,Table,TableRow,TableBody
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import TableBodyCell from "components/table/TableBodyCell";

export const PinCodeViewModel = (props) => {
  const { visible, callbackEvent,data} = props;
  return (
    <Spin>
      <KisshtDialog
        title={"Pin Code View"}
        maxWidth={"sm"}
        open={visible}
        handleClose={callbackEvent}
      >
        <DialogContent>
          <Card>
            <CardContent>
              <TableContainer style={{border:"solid 0.6px gray"}}>
              <Table striped className="cust-2-tab" style={{borderCollapse:"separate", borderSpacing : "0", width:"100%"}}>
                <TableBody>
                <TableRow>
                    <TableBodyCell className="common_table_title" >Pincode</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data.pincode}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >City Name	</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data.city_name || "--"}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title">State Name</TableBodyCell>
                    <TableBodyCell className="common_table_content">{data.state_name}</TableBodyCell>
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >Is Purple Active</TableBodyCell>
                    {data.is_purple_active === 1 ? <TableBodyCell className="common_table_content">YES</TableBodyCell> : <TableBodyCell className="common_table_content">NO</TableBodyCell>}
                  </TableRow>
                  <TableRow>
                    <TableBodyCell className="common_table_title" >Is Active	</TableBodyCell>
                    {data.is_active === "1" ? <TableBodyCell className="common_table_content">YES</TableBodyCell> : <TableBodyCell className="common_table_content">NO</TableBodyCell>}
                  </TableRow>
                </TableBody>
                </Table>
              </TableContainer> 
            </CardContent>
          </Card>
        </DialogContent>
      </KisshtDialog>
    </Spin>
  );
};

export default PinCodeViewModel;
